import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["groupIndex", "topLineType", "inverted", "borderBottom", "buttonHitArea", "colorConfig", "triggerType", "caretAnimation", "transitionStates", "active", "backgroundColor", "primitive"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { TitleConfig, BodyConfig, TypographyConfig } from '@vds-core/typography';
import { colors, calculateSpacing } from '@vds-core/theme';
import Icon from '@vds-core/icons';
import { getBackgroundColor } from './accordionUtil';
import { TextLink } from '@vds-core/buttons';
var coreTypescale = TypographyConfig.getTypescale();
var propTypes = {
  /**
   * When true, the header will take on the properties of an open drawer.
   */
  active: PropTypes.bool,

  /**
   * @ignore
   */
  backgroundColor: PropTypes.string,

  /**
   * Components to render inside of the AccordionHeader.  Can be any node but it is recommended to use provided components AccordionTitle and AccordionSubTitle.
   */
  children: PropTypes.node.isRequired,

  /**
   * @deprecated
   */
  className: PropTypes.string,

  /**
   * @deprecated onClick
   */
  clickHandler: PropTypes.func,
  // DEPRECATED

  /**
   * If provided, this function will be called if this AccordionHeader is clicked.  This will return (event, active state of the accordion item).
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onTrigger: PropTypes.func,

  /**
   * @ignore
   */
  groupIndex: PropTypes.number,

  /**
   * @ignore
   */
  groupId: PropTypes.string,

  /**
   * When true, text will be changed to a color of white. When using the inverted prop Accordion must be in a container element with a black background.
   */
  inverted: PropTypes.bool,

  /**
   * @ignore
   */
  sticky: PropTypes.bool,

  /**
   * @ignore
   */
  style: PropTypes.object,
  // <- Used for react-sticky

  /**
   * @ignore
   */
  testMode: PropTypes.bool,

  /**
   *	Header action item will be set either an icon or link based on string passed.
   */
  triggerType: PropTypes.oneOf(['icon', 'link']),

  /**
   * @ignore
   * When true, the drawer will remain open and not be able to close.
   */
  alwaysOpen: PropTypes.bool,

  /**
   * Set the styling of the component to the desktop, tablet, or mobile size based on passed prop. Desktop and tablet are the same size.
   */
  viewport: PropTypes.oneOf(['desktop', 'mobile', 'tablet']),

  /**
   * @ignore - Set a bottom border on the wrapper
   */
  borderBottom: PropTypes.bool,

  /**
   * @ignore
   * Pass a supported Typescale
   */
  typescale: PropTypes.oneOf(['VDS', 'MVP', 'Marketing']),

  /**
   * @ignore
   * Function to calculate the typography for trigger to be used
   */
  calcTrigger: PropTypes.func,

  /**
   * @ignore
   * Function to calculate the typography to be used
   */
  calcTypography: PropTypes.func,

  /**
   * @ignore - Turn on full button hit area (adjusts paddings accordingly)
   */
  buttonHitArea: PropTypes.bool,

  /**
   * @ignore - Turn on focus state for icon/link (shows on focus of entire hit area)
   */
  focusState: PropTypes.bool,

  /**
   * @ignore - Turn on the active state on click to adjust coloring of icon/link
   */
  activeState: PropTypes.bool,

  /**
   * @ignore - Set the trigger icon height
   */
  triggerHeight: PropTypes.number,

  /**
   * @ignore - Change the icon from +/- to carets
   */
  caretTrigger: PropTypes.bool,

  /**
   * @ignore - Turn on stroke width
   */
  mediumIcon: PropTypes.bool,

  /**
   * @ignore - To pass in the new icon data for the caret up and stroke width
   */
  iconData: PropTypes.object,

  /**
   * @ignore - To turn on the caret animation on hover
   */
  caretAnimation: PropTypes.bool,

  /**
   * @ignore - For the new blue color on the textLink
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore - To turn on the trigger color change on active (click)
   */
  triggerActiveAnimation: PropTypes.bool,

  /**
   * @ignore
   */
  linkStandalone: PropTypes.bool,

  /**
   * @ignore
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   */
  transitionStates: PropTypes.bool,

  /**
   * @ignore
   */
  triggerSize: PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string,

  /**
   * Passes a new primitive to the AccordionHeader Component
   */
  primitive: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div']),

  /**
   * Aria label used for accordion header.
   */
  ariaLabel: PropTypes.string
};

function _calcTypography(typescale, viewport) {
  return TitleConfig.getStyles(typescale, viewport, 'extraSmall');
}

function _calcTrigger(typescale, viewport) {
  return BodyConfig.getStyles(coreTypescale, 'desktop', 'small');
}

var defaultProps = {
  active: false,
  backgroundColor: null,
  className: null,
  onClick: null,
  onTrigger: function onTrigger() {},
  //clickHandler: null, // DEPRECATED
  groupIndex: 1,
  groupId: null,
  inverted: false,
  sticky: false,
  style: {},
  testMode: false,
  triggerType: 'icon',
  alwaysOpen: false,
  viewport: 'desktop',
  borderBottom: false,
  //1.0
  typescale: coreTypescale,
  calcTypography: _calcTypography,
  calcTrigger: _calcTrigger,
  buttonHitArea: false,
  focusState: false,
  triggerHeight: undefined,
  triggerSize: 'small',
  activeState: false,
  caretTrigger: false,
  mediumIcon: false,
  caretAnimation: false,
  transitionStates: false,
  triggerActiveAnimation: false,
  colorConfig: colors,
  linkStandalone: false,
  bodyConfig: BodyConfig,
  primitive: 'div',
  ariaLabel: undefined
};
var triggerWidth = 48;
var bodyFontWeight = 400;
var ToggleIconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "ToggleIconWrapper",
  componentId: "sc-19osi3m-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex: 1;\n  position: absolute;\n  right: 0;\n  top: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  line-height: ", ";\n  letter-spacing: 0;\n  font-weight: ", ";\n  > * {\n    outline: none;\n  }\n  ", ";\n\n  ", ";\n\n  ", ";\n  &:focus {\n    outline: none;\n  }\n  svg {\n    overflow: visible; //safari cuts off the border if overflow is not visible\n  }\n"])), calculateRem(-2), function (_ref) {
  var triggerFontConfig = _ref.triggerFontConfig;
  return calculateRem(triggerFontConfig.fontSize);
}, function (_ref2) {
  var triggerFontConfig = _ref2.triggerFontConfig;
  return triggerFontConfig.fontFamily;
}, function (_ref3) {
  var triggerFontConfig = _ref3.triggerFontConfig;
  return calculateRem(triggerFontConfig.lineHeight);
}, bodyFontWeight, function (_ref4) {
  var triggerHeight = _ref4.triggerHeight;
  return triggerHeight && "\n    transition: top 350ms cubic-bezier(0.22,0.61,0.36,1);\n    height: ".concat(calculateRem(triggerHeight), ";\n    top: ").concat(calculateRem(8), ";\n  ");
}, function (_ref5) {
  var activeState = _ref5.activeState;
  return activeState && "\n    &:active {\n      a {\n        color: ".concat(colors.coolGray6, " !important;\n        border-color: ").concat(colors.coolGray6, " !important;\n      }\n    }\n  ");
}, function (_ref6) {
  var caretAnimation = _ref6.caretAnimation,
      active = _ref6.active,
      triggerType = _ref6.triggerType;
  return caretAnimation && triggerType === 'icon' && "\n    justify-content: ".concat(active ? 'flex-start' : 'flex-end', ";\n    transform: rotate(").concat(active ? "-180deg" : "0deg", ");\n    transition: transform 350ms cubic-bezier(0.22, 0.61, 0.36, 1), top 350ms cubic-bezier(0.22,0.61,0.36,1); \n  ");
});
var StyledAccordionButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledAccordionButton",
  componentId: "sc-19osi3m-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  text-align: left;\n  width: 100%;\n  margin-bottom: 0;\n  padding: 0;\n  background: none;\n  border: 0;\n  overflow: visible;\n  ", ";\n  ", ";\n"])), function (_ref7) {
  var focusState = _ref7.focusState;
  return !focusState && "\n  &:focus  > .childrenWrapper {\n    outline: 5px auto -webkit-focus-ring-color;\n  } \n  ";
}, function (_ref8) {
  var focusState = _ref8.focusState,
      colorConfig = _ref8.colorConfig,
      inverted = _ref8.inverted;
  return focusState && "\n    &::-moz-focus-inner, \n    ::-moz-focus-inner {\n      border: 0;\n    }\n    &:active, &:hover {\n      svg {\n        border-color: transparent !important;\n      }\n    }\n    &:focus {\n      outline: none;\n      &:not(:hover):not(:active):not(:visited) {\n        a {\n          &:after {\n            content: \"\";\n            position: absolute;\n            top: ".concat(calculateRem(-3), ";\n            bottom: ").concat(calculateRem(-4), ";\n            right: ").concat(calculateRem(-3), ";\n            left: ").concat(calculateRem(-3), ";\n            border: ").concat(inverted ? "".concat(calculateRem(1), " dashed ").concat(colorConfig.white) : "".concat(calculateRem(1), " dashed ").concat(colorConfig.black), ";\n        }\n      }\n    }\n    &:focus {\n      .toggleIconWrapper > svg {\n        border: ").concat(inverted ? "".concat(calculateRem(1), " dashed ").concat(colorConfig.white) : "".concat(calculateRem(1), " dashed ").concat(colorConfig.black), ";\n    }\n  ");
});
var ChildrenWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "ChildrenWrapper",
  componentId: "sc-19osi3m-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  padding-right: ", ";\n  background-color: ", ";\n  color: ", ";\n  cursor: ", ";\n  overflow: visible;\n  font-family: ", ";\n  font-size: ", ";\n  letter-spacing: ", ";\n  font-weight: 700;\n  min-height: ", ";\n  line-height: ", ";\n\n  &:active,\n  &:hover,\n  &:focus {\n    outline: none;\n  }\n  ", ";\n"])), calculateRem(triggerWidth + 12), function (_ref9) {
  var inverted = _ref9.inverted,
      colorConfig = _ref9.colorConfig;
  return inverted ? colorConfig.black : colorConfig.white;
}, function (_ref10) {
  var inverted = _ref10.inverted,
      colorConfig = _ref10.colorConfig;
  return inverted ? colorConfig.white : colorConfig.black;
}, function (_ref11) {
  var alwaysOpen = _ref11.alwaysOpen;
  return alwaysOpen ? 'default' : 'pointer';
}, function (_ref12) {
  var viewport = _ref12.viewport,
      desktopType = _ref12.desktopType,
      mobileType = _ref12.mobileType;
  return viewport === 'mobile' ? mobileType.fontFamily : desktopType.fontFamily;
}, function (_ref13) {
  var viewport = _ref13.viewport,
      desktopType = _ref13.desktopType,
      mobileType = _ref13.mobileType;
  return viewport === 'mobile' ? calculateRem(mobileType.fontSize) : calculateRem(desktopType.fontSize);
}, function (_ref14) {
  var viewport = _ref14.viewport,
      desktopType = _ref14.desktopType,
      mobileType = _ref14.mobileType;
  return viewport === 'mobile' && mobileType.letterSpacing ? calculateRem(mobileType.letterSpacing) : desktopType.letterSpacing ? calculateRem(desktopType.letterSpacing) : '0';
}, function (_ref15) {
  var viewport = _ref15.viewport,
      desktopType = _ref15.desktopType,
      mobileType = _ref15.mobileType;
  return viewport === 'mobile' ? calculateRem(mobileType.lineHeight) : calculateRem(desktopType.lineHeight);
}, function (_ref16) {
  var viewport = _ref16.viewport,
      desktopType = _ref16.desktopType,
      mobileType = _ref16.mobileType;
  return viewport === 'mobile' ? calculateRem(mobileType.lineHeight) : calculateRem(desktopType.lineHeight);
}, function (_ref17) {
  var buttonHitArea = _ref17.buttonHitArea,
      active = _ref17.active,
      transitionStates = _ref17.transitionStates;
  return buttonHitArea && "\n  padding-top: ".concat(calculateSpacing('2X', 'px'), ";\n  padding-bottom: ").concat(active ? "".concat(calculateSpacing('3X', 'px')) : '23px' // Needs 23px this to remove flicker
  , ";\n  transition: ").concat(transitionStates ? 'padding-bottom 350ms ease' : 'none', ";\n  ");
}); //margin 0 and fontsize inherit are there to ignore defualt styling of h tags

var WrapperDiv = /*#__PURE__*/styled(function (_ref18) {
  var groupIndex = _ref18.groupIndex,
      topLineType = _ref18.topLineType,
      inverted = _ref18.inverted,
      borderBottom = _ref18.borderBottom,
      buttonHitArea = _ref18.buttonHitArea,
      colorConfig = _ref18.colorConfig,
      triggerType = _ref18.triggerType,
      caretAnimation = _ref18.caretAnimation,
      transitionStates = _ref18.transitionStates,
      active = _ref18.active,
      backgroundColor = _ref18.backgroundColor,
      primitive = _ref18.primitive,
      rest = _objectWithoutProperties(_ref18, _excluded);

  return /*#__PURE__*/React.createElement(primitive, rest);
}).withConfig({
  displayName: "WrapperDiv",
  componentId: "sc-19osi3m-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: inherit;\n  background-color: ", ";\n  border-top: ", "\n    solid\n    ", ";\n  padding-top: ", ";\n  position: relative;\n  width: 100%;\n  ", ";\n\n  ", ";\n  ", ";\n"])), function (rest) {
  return getBackgroundColor(rest);
}, function (_ref19) {
  var groupIndex = _ref19.groupIndex,
      topLineType = _ref19.topLineType;
  return calculateRem(!groupIndex && topLineType === 'heavy' ? 4 : 1);
}, function (_ref20) {
  var inverted = _ref20.inverted,
      colorConfig = _ref20.colorConfig;
  return inverted ? colorConfig.white : colorConfig.black;
}, function (_ref21) {
  var buttonHitArea = _ref21.buttonHitArea;
  return buttonHitArea ? '0' : calculateRem(6);
}, function (_ref22) {
  var groupIndex = _ref22.groupIndex,
      borderBottom = _ref22.borderBottom;
  return groupIndex && borderBottom && "\n    border-top: none;\n    ";
}, function (_ref23) {
  var colorConfig = _ref23.colorConfig;
  return colorConfig && "\n    &:hover {\n      a {\n        color: ".concat(colorConfig.blue, ";\n        border-bottom-color: ").concat(colorConfig.blue, ";\n      }\n    }\n  ");
}, function (_ref24) {
  var caretAnimation = _ref24.caretAnimation,
      triggerType = _ref24.triggerType,
      active = _ref24.active;
  return triggerType !== 'link' && caretAnimation && "\n      &:hover .toggleIconWrapper {\n          cursor: pointer;\n          top: ".concat(active ? calculateRem(6) : calculateRem(10), ";\n      }\n  ");
});

var AccordionHeader = /*#__PURE__*/function (_Component) {
  _inherits(AccordionHeader, _Component);

  var _super = _createSuper(AccordionHeader);

  function AccordionHeader(props) {
    var _this;

    _classCallCheck(this, AccordionHeader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "isFirefox", function () {
      return typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }());

    _defineProperty(_assertThisInitialized(_this), "_clicked", function (e) {
      var _document$getElementB;

      var groupId = _this.props.groupId;
      var hovered = _this.state.hovered;
      var focusWrapper = typeof document !== 'undefined' && ((_document$getElementB = document.getElementById("accordionHeader_".concat(groupId))) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.querySelector('svg'));

      if (_this.isFirefox && hovered) {
        //JAWS reads key events as mouse events, so if hovered that means this is a real click
        focusWrapper.style.border = 'none'; // removing border is better than blurring
      }

      if (_this.props.triggerActiveAnimation) {
        _this.setState({
          clicked: !_this.state.clicked
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_clearStates", function (e) {
      if (_this.props.triggerActiveAnimation) {
        _this.setState({
          clicked: false,
          hovered: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isAndroidDevice", function () {
      return typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('android') > -1;
    }());

    _this.state = {
      clicked: false,
      hovered: false
    };
    return _this;
  }

  _createClass(AccordionHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var groupId = this.props.groupId;
      this.accordionHeaderId = "accordionHeader_".concat(groupId);
      this.accordionAriaControlsId = "accordionDetail_".concat(groupId);
    }
  }, {
    key: "render",
    value: function render() {
      var _document$getElementB2,
          _this2 = this;

      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          clickHandler = _this$props.clickHandler,
          onClick = _this$props.onClick,
          groupIndex = _this$props.groupIndex,
          groupId = _this$props.groupId,
          inverted = _this$props.inverted,
          sticky = _this$props.sticky,
          style = _this$props.style,
          testMode = _this$props.testMode,
          backgroundColor = _this$props.backgroundColor,
          viewport = _this$props.viewport,
          triggerType = _this$props.triggerType,
          alwaysOpen = _this$props.alwaysOpen,
          onTrigger = _this$props.onTrigger,
          borderBottom = _this$props.borderBottom,
          calcTrigger = _this$props.calcTrigger,
          typescale = _this$props.typescale,
          calcTypography = _this$props.calcTypography,
          buttonHitArea = _this$props.buttonHitArea,
          focusState = _this$props.focusState,
          triggerHeight = _this$props.triggerHeight,
          activeState = _this$props.activeState,
          caretTrigger = _this$props.caretTrigger,
          iconData = _this$props.iconData,
          mediumIcon = _this$props.mediumIcon,
          caretAnimation = _this$props.caretAnimation,
          transitionStates = _this$props.transitionStates,
          triggerActiveAnimation = _this$props.triggerActiveAnimation,
          colorConfig = _this$props.colorConfig,
          triggerSize = _this$props.triggerSize,
          linkStandalone = _this$props.linkStandalone,
          bodyConfig = _this$props.bodyConfig,
          analyticsTrack = _this$props.analyticsTrack,
          track = _this$props.track,
          clickStream = _this$props.clickStream,
          cta = _this$props.cta,
          level = _this$props.level,
          position = _this$props.position,
          dataTrack = _this$props.dataTrack,
          topLineType = _this$props.topLineType,
          primitive = _this$props.primitive,
          ariaLabel = _this$props.ariaLabel;
      var desktopType = calcTypography(typescale, 'desktop');
      var mobileType = calcTypography(typescale, 'mobile');
      var triggerFontConfig = calcTrigger(typescale, viewport);
      var focusWrapper = typeof document !== 'undefined' && ((_document$getElementB2 = document.getElementById("accordionHeader_".concat(groupId))) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.querySelector('svg'));

      function _onClick(e) {
        clickHandler ? clickHandler(e) : onClick && onClick(e);
        onTrigger && onTrigger(e);
      }

      var _onFocus = function _onFocus(e) {
        return _this2.isFirefox ? focusWrapper.style.border = "1px dashed ".concat(colors.black) : null;
      }; //set styles for firefox because we cant use tabindex -1


      var _onBlur = function _onBlur(e) {
        return _this2.isFirefox ? focusWrapper.style.border = 'none' : null;
      };

      var _onHover = function _onHover(e) {
        return _this2.setState({
          hovered: true
        });
      };

      var collapseIcon = caretTrigger ? 'down-caret' : 'minus';
      var expandIcon = caretTrigger ? 'down-caret' : 'plus';
      return /*#__PURE__*/React.createElement(WrapperDiv, {
        className: className,
        "data-testid": sticky && testMode ? "sticky_".concat(groupId) : undefined,
        id: this.accordionHeaderId,
        backgroundColor: backgroundColor,
        groupIndex: groupIndex,
        inverted: inverted,
        borderBottom: borderBottom,
        buttonHitArea: buttonHitArea,
        colorConfig: colorConfig,
        triggerType: triggerType,
        caretAnimation: caretAnimation,
        transitionStates: transitionStates,
        active: active,
        topLineType: topLineType,
        primitive: primitive
      }, /*#__PURE__*/React.createElement(StyledAccordionButton, {
        className: "accordionButton",
        "aria-expanded": active,
        "aria-controls": this.accordionAriaControlsId,
        onClick: _onClick,
        type: "button",
        tabIndex: 0,
        focusState: focusState,
        onFocus: _onFocus,
        onBlur: _onBlur,
        inverted: inverted,
        onMouseDown: this._clicked,
        onMouseUp: this._clicked,
        onMouseEnter: _onHover,
        onMouseLeave: this._clearStates,
        colorConfig: colorConfig,
        "aria-label": ariaLabel,
        "data-clickstream": clickStream,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-sitecat-datatrack": dataTrack,
        "data-sitecat-position": position,
        "data-sitecat-level": level,
        "data-sitecat-cta": cta
      }, /*#__PURE__*/React.createElement(ChildrenWrapper, {
        className: "childrenWrapper",
        tabIndex: this.isFirefox ? undefined : -1,
        alwaysOpen: alwaysOpen,
        viewport: viewport,
        active: active,
        desktopType: desktopType,
        mobileType: mobileType,
        focusState: focusState,
        buttonHitArea: buttonHitArea,
        triggerType: triggerType,
        caretAnimation: caretAnimation,
        transitionStates: transitionStates,
        colorConfig: colorConfig,
        inverted: inverted,
        "aria-hidden": this.isAndroidDevice
      }, React.Children.map(children, function (child, index) {
        if (child && child.type && child.type.displayName === 'AccordionTitle') {
          return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
            inverted: inverted
          }));
        } else if (child && child.type && child.type.displayName === 'AccordionSubTitle') {
          return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
            inverted: inverted
          }));
        } else {
          return child;
        }
      })), !alwaysOpen && /*#__PURE__*/React.createElement(ToggleIconWrapper, {
        className: "toggleIconWrapper",
        tabIndex: -1,
        triggerHeight: triggerHeight,
        activeState: activeState,
        triggerFontConfig: triggerFontConfig,
        active: active,
        colorConfig: colorConfig,
        caretAnimation: caretAnimation,
        triggerType: triggerType,
        "aria-hidden": "true"
      }, triggerType === 'link' && /*#__PURE__*/React.createElement(TextLink, {
        tabIndex: -1,
        type: linkStandalone ? 'standAlone' : 'inline',
        size: linkStandalone ? 'small' : undefined,
        bodyConfig: bodyConfig,
        activeState: activeState && this.state.clicked,
        typescale: typescale,
        inverted: inverted,
        "aria-hidden": "true"
      }, active ? 'Cancel' : 'Change'), triggerType === 'icon' && /*#__PURE__*/React.createElement(Icon, {
        tabIndex: -1,
        name: active ? collapseIcon : expandIcon,
        inverted: inverted,
        color: this.state.clicked ? colorConfig.coolGray6 : colorConfig.black,
        ariaLabel: active ? 'expanded' : 'collapsed',
        size: triggerSize,
        "aria-hidden": "true",
        data: iconData,
        weight: mediumIcon ? 'medium' : 'light',
        vectorEffect: "non-scaling-stroke",
        focusState: focusState,
        focusRadius: focusState ? '0%' : undefined,
        borderOffset: focusState ? '2px' : undefined,
        hasStroke: true
      }))));
    }
  }]);

  return AccordionHeader;
}(Component);

_defineProperty(AccordionHeader, "componentType", 'AccordionHeader');

AccordionHeader.defaultProps = defaultProps;
AccordionHeader.propTypes = propTypes;
export default AccordionHeader;